var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"clearfix grid-item-badges\"><span class=\"grid-item-badge badge badge-{{::badge.replace(' ', '-').toLowerCase()}}\" ng-repeat=\"badge in ::$ctrl.badges\">{{::badge}}</span></div>";
var id1="tags-badges.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;